import { produce } from 'immer'
import { create } from 'zustand'

import { Filters } from 'types/project'

export type AlertUIState = {
  isAlertDrawerOpen: boolean
  setIsAlertDrawerOpen: (isAlertDrawerOpen: boolean) => void
  alertRequest: Filters | undefined
  setAlertRequest: (alertRequest: Filters | undefined) => void
  resetAlertUI: () => void
}

const initialState = {
  isAlertDrawerOpen: false,
  alertRequest: undefined as Filters | undefined,
}

export const useAlertUIStore = create<AlertUIState>()((set) => ({
  ...initialState,

  setIsAlertDrawerOpen: (isAlertDrawerOpen) =>
    set(
      produce((s: AlertUIState) => {
        s.isAlertDrawerOpen = isAlertDrawerOpen
      }),
    ),

  setAlertRequest: (alertRequest) =>
    set(
      produce((s: AlertUIState) => {
        s.alertRequest = alertRequest
      }),
    ),

  resetAlertUI: () => set(initialState),
}))
